import type { SerializedRichText } from './types'

export default function plainTextToSerializedRichText(content: string): SerializedRichText {
  return { serialization_method: 'plain_text', content }
}
